/**
 * @description render elem
 * @author wangfupeng
 */

import { h, VNode } from "snabbdom";
import { DomEditor, IDomEditor, SlateElement } from "@wangeditor/editor";
import { VariableElement } from "./types";
import emitter from "./mitt";
import { getLeftAndTop } from "./plugin";

function renderVariable(elem: SlateElement, children: VNode[] | null, editor: IDomEditor): VNode {
  // 当前节点是否选中
  const selected = DomEditor.isNodeSelected(editor, elem);
  const { label = "", value = "" } = elem as VariableElement;

  // 构建 vnode
  const vnode = h(
    "span",
    {
      props: {
        contentEditable: false // 不可编辑
      },
      style: {
        marginLeft: "3px",
        marginRight: "3px",
        backgroundColor: "var(--el-color-primary-light-9)",
        border: selected // 选中/不选中，样式不一样
          ? "2px solid var(--w-e-textarea-selected-border-color)" // wangEditor 提供了 css var https://www.wangeditor.com/v5/theme.html
          : "2px solid transparent",
        borderRadius: "3px",
        padding: "0 3px",
        cursor: "pointer",
        color: "var(--el-color-primary)",
        borderColor: "var(--el-color-primary-light-8)"
      },
      on: {
        click: (e) => {
          if (editor.isDisabled()) return;
          const { top, left, isRight } = getLeftAndTop(editor, elem);
          //@ts-ignore
          const { width, height } = e.target.getBoundingClientRect();
          emitter.emit("show", {
            top: top + height,
            left: left - (!isRight ? width : 0),
            value: value
          });
          // 监听，隐藏 modal（异步，等待 modal 渲染后再监听）
          setTimeout(() => {
            function _hide() {
              // if (hide) hide(newEditor);
              emitter.emit("hide", editor);
            }
            editor.once("fullScreen", _hide);
            editor.once("unFullScreen", _hide);
            editor.once("scroll", _hide);
            editor.once("modalOrPanelShow", _hide);
            editor.once("modalOrPanelHide", _hide);

            function hideOnChange() {
              if (editor.selection != null) {
                _hide();
                editor.off("change", hideOnChange); // 及时解绑
              }
            }
            editor.on("change", hideOnChange);
          });
        }
      }
    },
    `${label}` // 如 `${张三}`
  );

  return vnode;
}

const conf = {
  type: "variable", // 节点 type ，重要！！！
  renderElem: renderVariable
};

export default conf;
